/* Phitkoo sticker drop: filters, 3D tilt, quick-add feedback, apply/remove switch. */
(() => {
  if (window.pkStickersReady) return;
  window.pkStickersReady = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');

  const init = root => {
    // Character filter tabs
    root.querySelectorAll('[data-stk]').forEach(sec => {
      const tabs = sec.querySelectorAll('[data-stk-filter]');
      tabs.forEach(tab => tab.addEventListener('click', () => {
        const f = tab.dataset.stkFilter;
        tabs.forEach(t => t.setAttribute('aria-selected', String(t === tab)));
        sec.querySelectorAll('[data-stk-rail] [data-stk-card]').forEach(card => card.classList.toggle('is-hidden', f !== 'all' && card.dataset.char !== f));
        sec.querySelector('[data-stk-rail]')?.scrollTo({left: 0, behavior: reduce.matches ? 'auto' : 'smooth'});
      }));
    });

    // Gentle 3D tilt that follows the pointer
    if (fine.matches && !reduce.matches) root.querySelectorAll('.pk-stk-card').forEach(card => {
      if (card.dataset.tilt) return;
      card.dataset.tilt = '1';
      card.addEventListener('pointermove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        card.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', () => { card.style.removeProperty('--rx'); card.style.removeProperty('--ry'); });
    });

    // Apply / Remove switch
    root.querySelectorAll('[data-stk-howto]').forEach(box => {
      box.querySelectorAll('[data-howto]').forEach(btn => btn.addEventListener('click', () => {
        const mode = btn.dataset.howto;
        box.dataset.mode = mode;
        box.querySelectorAll('[data-howto]').forEach(b => b.setAttribute('aria-selected', String(b === btn)));
        box.querySelectorAll('[data-howto-panel]').forEach(p => { p.hidden = p.dataset.howtoPanel !== mode; });
      }));
    });
  };

  // Quick add: fly the sticker into the cart and tick the button
  const fly = (img, cart) => {
    if (!img || !cart || reduce.matches) return;
    const a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width || !b.width) return;
    const size = Math.min(a.width, a.height, 110);
    const c = img.cloneNode();
    c.removeAttribute('srcset'); c.removeAttribute('sizes');
    c.src = img.currentSrc || img.src;
    c.className = 'pk-fly';
    c.style.cssText = `width:${size}px;height:${size}px;left:${a.left + a.width / 2 - size / 2}px;top:${a.top + a.height / 2 - size / 2}px;object-fit:contain;border-radius:0;border:0;background:transparent;box-shadow:none`;
    document.body.append(c);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    c.animate([{transform: 'translate(0,0) rotate(0) scale(1)'}, {transform: `translate(${dx * .5}px,${dy * .5 - 70}px) rotate(-20deg) scale(.6)`, offset: .55}, {transform: `translate(${dx}px,${dy}px) rotate(-40deg) scale(.15)`, opacity: .3}],
      {duration: 800, easing: 'cubic-bezier(.55,0,.25,1)'}).onfinish = () => { c.remove(); cart.classList.remove('pk-bump'); void cart.offsetWidth; cart.classList.add('pk-bump'); };
  };
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-stk-card] form[data-ajax-cart]')) return;
    const card = form.closest('[data-stk-card]');
    const btn = form.querySelector('button[type="submit"]');
    const img = card.querySelector('.pk-stk-card__img, .pk-pack__media img, .pk-upsell__media img');
    const added = document.body.dataset.cartAdded || '';
    const label = btn.innerHTML;
    const round = btn.classList.contains('pk-stk-card__add');
    let done = false;
    const obs = new MutationObserver(() => {
      // keep the round button an icon while the cart script swaps its text
      if (round && !btn.classList.contains('is-added') && btn.textContent.trim() !== '+') { btn.innerHTML = label; }
      if (done || btn.getAttribute('aria-busy') === 'true') return;
      if (form.querySelector('[data-cart-error]')?.textContent) { done = true; obs.disconnect(); if (round) btn.innerHTML = label; return; }
      if (form.dataset.cartPending === 'false' || btn.textContent.trim() === added.trim()) {
        done = true;
        fly(img, document.querySelector('[data-cart-link]'));
        if (round) {
          btn.classList.add('is-added'); btn.innerHTML = '<span aria-hidden="true">&#10003;</span>';
          setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = label; obs.disconnect(); }, 1500);
        } else setTimeout(() => obs.disconnect(), 1500);
      }
    });
    obs.observe(btn, {attributes: true, attributeFilter: ['aria-busy'], childList: true, characterData: true, subtree: true});
    setTimeout(() => obs.disconnect(), 12000);
  }, true);

  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
